import React from 'react';
import { MultiWebClientSubItemModel } from '@/User/domain';
import { MasterSubItem } from '../atoms/MasterSubItem';
import { DROPDOWN_STYLES } from '../constants/masterStyles';

interface SubItemListProps {
  subItems: MultiWebClientSubItemModel[];
  hoveredSubKey: string | null;
  onSubItemClick: (subItem: MultiWebClientSubItemModel) => void;
  onSubItemMouseEnter: (key: string) => void;
  onSubItemMouseLeave: () => void;
}

/**
 * Componente molecular que renderiza una lista scrollable de sub-items (sucursales).
 * Aplica scroll solo cuando hay más de 6 items.
 * 
 * @param subItems - Lista de sub-items a mostrar
 * @param hoveredSubKey - Clave del sub-item actualmente hovereado
 * @param onSubItemClick - Función para manejar el clic en un sub-item
 * @param onSubItemMouseEnter - Función para manejar el hover sobre un sub-item
 * @param onSubItemMouseLeave - Función para manejar cuando sale del hover
 */
export const MasterSubItemList: React.FC<SubItemListProps> = ({
  subItems,
  hoveredSubKey,
  onSubItemClick,
  onSubItemMouseEnter,
  onSubItemMouseLeave,
}) => {
  if (!Array.isArray(subItems) || subItems.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        ...DROPDOWN_STYLES.subItemListContainer,
        overflowY: subItems.length > 6 ? 'auto' : 'visible',
      }}
    >
      {subItems.map((sub) => (
        <MasterSubItem
          key={sub.name + sub.code}
          subItem={sub}
          isHovered={hoveredSubKey === sub.name + sub.code}
          onMouseEnter={() => onSubItemMouseEnter(sub.name + sub.code)}
          onMouseLeave={onSubItemMouseLeave}
          onClick={() => onSubItemClick(sub)}
        />
      ))}
    </div>
  );
};
